import styled from "styled-components";

export const MainWrapper = styled.div`
  height: calc(100vh - 60px); /* Ajuste para altura do header do Template */
  background-color: #f8f9fa;
  padding: 20px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  /* Garantir que container e linhas ocupem toda a altura disponível */
  .container-fluid,
  .container {
    height: 100%;
  }
  .container-fluid > .row,
  .container > .row {
    height: 100%;
  }
  .container-fluid > .row > .col-sm-12,
  .container > .row > .col-sm-12 {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  @media (max-width: 767px) {
    height: calc(100vh - 80px); /* Header maior no mobile */
  }
`;

export const MainContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .container-fluid {
    height: 100%;
  }

  .full-height-row {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    overflow: hidden;
  }

  /* Fazer as colunas internas ocuparem 100% e permitirem rolagem nos cards */
  .full-height-row > .col,
  .full-height-row > [class*='col-'] {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .sidebar-card,
  .editor-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .sidebar-card .card-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
  }

  .editor-card .card-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden; /* scroll control inside PDF wrapper */
  }

  .pdf-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .card {
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    
    .card-header {
      border-radius: 10px 10px 0 0 !important;
      border-bottom: 1px solid #dee2e6;
      
      h5 {
        font-weight: 600;
      }
    }
  }

  .form-control-lg {
    border-radius: 8px;
    border: 2px solid #e9ecef;
    transition: all 0.3s ease;
    
    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  .btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
  }

  .alert {
    border-radius: 8px;
    border: none;
  }

  .sticky-top {
    position: sticky;
    z-index: 1020;
  }

  iframe {
    border-radius: 0 0 10px 10px;
  }

  .font-weight-bold {
    font-weight: 600 !important;
  }

  .text-muted {
    color: #6c757d !important;
  }

  .bg-light {
    background-color: #f8f9fa !important;
  }

  .shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  }

  .border-0 {
    border: 0 !important;
  }

  .d-grid {
    display: grid !important;
  }

  .gap-2 {
    gap: 0.5rem !important;
  }

  /* Estilos específicos para o resumo de marcações */
  .marcacoes-container {
    .marcacao-item {
      transition: all 0.2s ease;
    }

    .badge {
      font-size: 0.8em;
    }

    .marcacao-image {
      transition: transform 0.2s ease;
      
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  /* Melhorias no layout responsivo */
  @media (max-width: 992px) {
    .col-lg-10 {
      margin-bottom: 2rem;
    }

    .sticky-top {
      position: relative !important;
    }
  }
`;